<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_689" data-name="Rectangle 689" width="248.387" height="219.357" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="How_C-suite_executives_choose_their_partners" data-name="How C-suite executives choose
their partners" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">How C-suite executives choose</tspan>
        <tspan x="0" y="28">their partners</tspan>
    </text>
    <text id="_ESG_credentials_Ability_to_support_recommendations_with_data_research_and_evidence" data-name="•  ESG credentials
•  Ability to support
    recommendations with
    data, research and evidence" transform="translate(40 201)" fill="#fff" font-size="24"
          font-family="Metric-Regular, Metric">
        <tspan x="0" y="23" xml:space="preserve">•  ESG credentials</tspan>
        <tspan x="0" y="51" xml:space="preserve">•  Ability to support </tspan>
        <tspan x="0" y="79" xml:space="preserve">    recommendations with data,</tspan>
        <tspan x="0" y="107" xml:space="preserve">    research and evidence</tspan>
    </text>
    <text id="CIO" transform="translate(40 101)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric"
          font-weight="700">
        <tspan x="0" y="81">CIO</tspan>
    </text>
    <g id="Group_1351" data-name="Group 1351" transform="translate(78 365)">
        <g id="Group_1350" data-name="Group 1350" clip-path="url(#clip-path)">
            <path id="Path_14669" data-name="Path 14669"
                  d="M153.925,218.342a27.555,27.555,0,0,0-23.085-27.186,28.282,28.282,0,0,1-34.373-.167,27.551,27.551,0,0,0-24.291,27.353"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14670" data-name="Path 14670"
                  d="M88.3,164.739a25.521,25.521,0,1,1,25.522,25.522A25.522,25.522,0,0,1,88.3,164.739Z" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14671" data-name="Path 14671" d="M168.485,218.357V205.746h7.757v-9.573H187.76" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14672" data-name="Path 14672" d="M37.3,130.006l-.306,88.351H168.484" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14673" data-name="Path 14673" d="M146.7,27.953h42.41V135.919" fill="none" stroke="#008ed2"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14674" data-name="Path 14674" d="M36.989,90.593V27.953h38.2" fill="none" stroke="#008ed2"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14675" data-name="Path 14675"
                  d="M37.295,130.006l-.027-14.051A30.827,30.827,0,0,1,68.1,85.127h9.717a34.845,34.845,0,0,1-34.347,34.841l-5.071.073s9.01-16.894,18.4-19.522"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14676" data-name="Path 14676" d="M101.209,104.529l13.053,13.053,30.9-30.9" fill="none"
                  stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14677" data-name="Path 14677" d="M215.8,131.724h16.579v-9.877H215.8v17.571" fill="none"
                  stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14678" data-name="Path 14678"
                  d="M215.586,139.4l-3.812.015a6.758,6.758,0,0,0-.682.035,24.813,24.813,0,0,0-22.038,21.209m26.75-21.242a24.816,24.816,0,0,1,22.379,21.243m9.2,36.446H241.1V166.732c-.153,0,0-5.522,0-5.522H185.76v28.769"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14679" data-name="Path 14679"
                  d="M217.585,170.7v26.406H209.65V170.7a3.968,3.968,0,0,1,7.935,0Z" fill="none" stroke="#fff"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14680" data-name="Path 14680"
                  d="M197.943,166.732h0a3.967,3.967,0,0,1,3.967,3.967V197.1h-7.934V170.7A3.967,3.967,0,0,1,197.943,166.732Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14681" data-name="Path 14681" d="M233.26,197.106h-7.935V170.7a3.967,3.967,0,0,1,7.935,0Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14682" data-name="Path 14682"
                  d="M32.156,121.137c0-16.753-8.447-27.18-23.545-27.18H1a27.292,27.292,0,0,0,26.9,27.289l4.254-.109s-7.339-13.066-14.69-15.124"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14683" data-name="Path 14683"
                  d="M119.677,22.831a9.02,9.02,0,1,1-9.02-9.02,9.02,9.02,0,0,1,9.02,9.02" fill="none" stroke="#fff"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.852"/>
            <path id="Path_14684" data-name="Path 14684"
                  d="M101.423,29.776a15.43,15.43,0,0,0-6.229,12.383v2.577a5.156,5.156,0,0,0,5.154,5.154h20.617a5.156,5.156,0,0,0,5.154-5.154V42.159a15.43,15.43,0,0,0-6.229-12.383"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.852"/>
            <path id="Path_14685" data-name="Path 14685"
                  d="M140.294,9.945a9.02,9.02,0,1,1-9.02-9.019,9.019,9.019,0,0,1,9.02,9.019" fill="none" stroke="#fff"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.852"/>
            <path id="Path_14686" data-name="Path 14686"
                  d="M125.676,37h15.906a5.156,5.156,0,0,0,5.154-5.154V29.271a15.421,15.421,0,0,0-6.229-12.378"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.852"/>
            <path id="Path_14687" data-name="Path 14687"
                  d="M99.061,9.945A9.02,9.02,0,1,1,90.041.926a9.019,9.019,0,0,1,9.02,9.019" fill="none" stroke="#fff"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1.852"/>
            <path id="Path_14688" data-name="Path 14688"
                  d="M80.808,16.893a15.422,15.422,0,0,0-6.229,12.38V31.85A5.156,5.156,0,0,0,79.733,37H96.126"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.852"/>
        </g>
    </g>
</svg>
